module.exports = {"client":"Client Info & Contact","num_of_customer":"Amount of Clients","customer_name":"Full Name","birthday":"Birthday","phone":"Phone","email":"Email","gender":"Gender","male":"Male","female":"Female","unknown":"Unknown","other_contact_method":"Other Contact","other_contact_number":"Account"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/individualtour/create/client.json
// module id = ngww
// module chunks = 58